import { createWebHistory, createRouter } from 'vue-router'
import HomePage from '../view/home/HomePage.vue'
import ProfilePage from '@/view/profile/ProfilePage.vue'
import AccountEditPage from '@/view/profile/AccountEditPage.vue'
import HelpCenterPage from '@/view/help_center/HelpCenterPage.vue'
import OrderList from '@/view/orderList/OrderList.vue'
import LoginPage from '@/view/login/LoginPage.vue'

const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/home',
    name: 'HomePage',
    component: HomePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/order_list',
    name: 'OrderList',
    component: OrderList,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'ProfilePage',
    component: ProfilePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/account_edit',
    name: 'AccountEditPage',
    component: AccountEditPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/help_center',
    name: 'HelpCenterPage',
    component: HelpCenterPage,
    meta: { requiresAuth: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
})

// ✅ Navigation guard for auth protection
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('token')

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'LoginPage' })
  } else if (to.name === 'LoginPage' && isAuthenticated) {
    next({ name: 'HomePage' }) // Prevent logged-in users from going to login page
  } else {
    next()
  }
})

export default router
